import type { Client, ClientLifecycle, ClientAutomationSettings } from '~/types/models';

export const DEFAULT_REENGAGEMENT_DAYS = 90;

export function normalizeClientLifecycleAutomationSettings(
    settings?: ClientAutomationSettings | null,
): Required<Pick<ClientAutomationSettings, 'promptOnWon' | 'alertOnInvoiceOverdue'>> & {
    reengageAfterInactiveDays: number | null;
    updatedAt?: unknown;
} {
    const normalizedDays = settings?.reengageAfterInactiveDays;
    return {
        promptOnWon: settings?.promptOnWon !== false,
        alertOnInvoiceOverdue: settings?.alertOnInvoiceOverdue !== false,
        reengageAfterInactiveDays: typeof normalizedDays === 'number' && normalizedDays > 0
            ? normalizedDays
            : normalizedDays === null
                ? null
                : DEFAULT_REENGAGEMENT_DAYS,
        updatedAt: settings?.updatedAt,
    };
}

function resolveLifecycle(input?: Client | ClientLifecycle | null): ClientLifecycle | null {
    if (!input) {
        return null;
    }

    if ('lifecycle' in input) {
        return input.lifecycle || null;
    }

    return input as ClientLifecycle;
}

export function clientReengagementDays(input?: Client | ClientLifecycle | null): number | null {
    return normalizeClientLifecycleAutomationSettings(resolveLifecycle(input)?.automationSettings).reengageAfterInactiveDays;
}

export function clientShouldPromptOnWon(input?: Client | ClientLifecycle | null): boolean {
    return normalizeClientLifecycleAutomationSettings(resolveLifecycle(input)?.automationSettings).promptOnWon;
}

export function clientShouldAlertOnInvoiceOverdue(input?: Client | ClientLifecycle | null): boolean {
    return normalizeClientLifecycleAutomationSettings(resolveLifecycle(input)?.automationSettings).alertOnInvoiceOverdue;
}
